// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"a3w5E","background-$(backgroundColor)":"b3w5E","bg":"c3w5E","ant":"d3w5E","redTheme":"e3w5E","greenTheme":"f3w5E"};